import apiRequest from '../api/apiRequest';
import { StripePortalSession } from '../types';

export async function getStripePortalSession(
  stripeCustomerID: string,
  previewPriceId?: string,
  newQuantity?: number,
) {
  const params = new URLSearchParams();
  if (previewPriceId) {
    params.append('previewPriceId', previewPriceId);
  }
  if (newQuantity) {
    params.append('newQuantity', newQuantity.toString());
  }
  params.append('returnURL', window.location.href);
  return apiRequest<StripePortalSession>(
    'user',
    `/stripe/customer-portal/${stripeCustomerID}?${params.toString()}`,
  );
}
